import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import Textfield from "@atlaskit/textfield";
import { setPaginationVariableScript } from "../utils/paginationUtil";
import { autoIncrementTemplate } from "../utils/paginationTemplates";
import { setEditorSaved } from "../../../../../../../../redux/actions/integrationActions";

const AutoIncrementEditor = ({ action, variableName }) => {
  const [startValue, setStartValue] = useState(0);
  const [incrementValue, setIncrementValue] = useState(1);
  const dispatch = useDispatch();
  const pagination = action?.pagination;
  const paginationScript = pagination?.variable?.script;
  const paginationVariableName = variableName ?? pagination?.variable?.name;
  const previousNameRef = useRef(paginationVariableName);

  useEffect(() => {
    if (!paginationScript) {
      return;
    }
    const regExp = /(?<=incrementValue=)[^";]*/;
    const incValue = paginationScript.match(regExp);
    if (incValue && incValue.length > 0) {
      setIncrementValue(incValue[0]);
    }

    const regExp2 = /(?<=startValue=)[^";]*/;
    const start = paginationScript.match(regExp2);
    if (start && start.length > 0) {
      setStartValue(start[0]);
    }
  }, [paginationScript]);

  useEffect(() => {
    if (!pagination) {
      previousNameRef.current = paginationVariableName;
      return;
    }
    if (previousNameRef.current === undefined) {
      previousNameRef.current = paginationVariableName;
      return;
    }
    if (previousNameRef.current === paginationVariableName) {
      return;
    }
    previousNameRef.current = paginationVariableName;
    const script = autoIncrementTemplate(paginationVariableName, startValue, incrementValue);
    setPaginationVariableScript(pagination, script);
  }, [paginationVariableName, pagination, startValue, incrementValue]);

  const effectiveVariableName = paginationVariableName || "page";

  const onChangeStartValue = (e) => {
    setStartValue(e.target.value);
    const script = autoIncrementTemplate(effectiveVariableName, e.target.value, incrementValue);
    setPaginationVariableScript(pagination, script);
    dispatch(setEditorSaved(false));
  };
  const onChangeIncrementValue = (e) => {
    setIncrementValue(e.target.value);
    const script = autoIncrementTemplate(effectiveVariableName, startValue, e.target.value);
    setPaginationVariableScript(pagination, script);
    dispatch(setEditorSaved(false));
  };
  return (
    <>
      Start value:
      <Textfield value={startValue} isCompact onChange={onChangeStartValue} />
      Increment with:
      <Textfield value={incrementValue} isCompact onChange={onChangeIncrementValue} />
      When iHub loads a new page, it will add this amount to the start value. example. page=1, page=2 etc.
    </>
  );
};

export default AutoIncrementEditor;
